import axios, { type AxiosInstance, type AxiosRequestConfig, type AxiosResponse } from 'axios'

// 通用 axios 实例创建器
class HttpClient {
  private axiosInstance: AxiosInstance

  constructor(baseURL: string, options?: AxiosRequestConfig) {
    this.axiosInstance = axios.create({
      baseURL,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      },
      ...options
    })

    this.setupInterceptors()
  }

  private setupInterceptors() {
    // 请求拦截器
    this.axiosInstance.interceptors.request.use(
      config => config,
      error => Promise.reject(error)
    )

    // 响应拦截器
    this.axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => response.data,
      error => {
        // 统一错误处理
        console.error('请求失败:', error)
        return Promise.reject(error)
      }
    )
  }

  // GET 请求
  public get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.get(url, config)
  }

  // POST 请求
  public post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.post(url, data, config)
  }

  // PUT 请求
  public put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.put(url, data, config)
  }

  // DELETE 请求
  public delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.delete(url, config)
  }

  // PATCH 请求
  public patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
    return this.axiosInstance.patch(url, data, config)
  }
}

// 埋点上报专用实例
export const reportHttp = new HttpClient(import.meta.env.VITE_REPORT_API)

// 通用 API 实例（可用于其他接口）
export const apiHttp = new HttpClient(import.meta.env.VITE_BASE_API)

// 导出 HttpClient 类，方便创建其他实例
export { HttpClient }
